var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M22.071 0H1.929C0.864 0 0 0.864 0 1.929V22.071C0 23.136 0.864 24 1.929 24H22.071C23.136 24 24 23.136 24 22.071V1.929C24 0.864 23.136 0 22.071 0ZM22.071 22.08C8.637 22.077 1.92 22.074 1.92 22.071C1.923 8.637 1.926 1.92 1.929 1.92C15.363 1.923 22.08 1.926 22.08 1.929C22.077 15.363 22.074 22.08 22.071 22.08ZM3.558 8.997H7.119V20.451H3.558V8.997ZM5.34 7.431C6.477 7.431 7.404 6.507 7.404 5.367C7.404 5.09595 7.35061 4.82756 7.24689 4.57714C7.14316 4.32673 6.99113 4.09919 6.79947 3.90753C6.60781 3.71587 6.38027 3.56384 6.12986 3.46011C5.87944 3.35639 5.61105 3.303 5.34 3.303C5.06895 3.303 4.80056 3.35639 4.55014 3.46011C4.29973 3.56384 4.07219 3.71587 3.88053 3.90753C3.68887 4.09919 3.53684 4.32673 3.43311 4.57714C3.32939 4.82756 3.276 5.09595 3.276 5.367C3.273 6.507 4.197 7.431 5.34 7.431ZM12.909 14.784C12.909 13.29 13.194 11.844 15.045 11.844C16.869 11.844 16.896 13.551 16.896 14.88V20.451H20.454V14.169C20.454 11.085 19.788 8.712 16.185 8.712C14.454 8.712 13.293 9.663 12.816 10.563H12.768V8.997H9.351V20.451H12.909V14.784Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.4e2e88e578402244c82d83fed1003801.svg";
export { ForwardRef as ReactComponent };